// extracted by mini-css-extract-plugin
export var externalLink = "_8g-0";
export var internalLinkLabel = "_8g-1";